<template>
  <div class="box">
    <p>
      <span class="label">本政策发布日期：</span>
      <span>2022年9月1日</span>
    </p>
    <p class="mar_bottom">
      <span class="label">最近更新日期：</span>
      <span>2022年9月1日</span>
    </p>

    <p class="mar_bottom">宇泰保险经纪（北京）有限公司（以下简称“宇泰保险经纪”或“我们”）非常重视个人信息的保密和安全，并一直致力于依法保护使用宇泰云服在线的产品和服务（以下简称“宇泰云服在线服务”）之客户（以下简称“客户”或“您”）的个人信息和隐私安全。您在使用宇泰云服在线服务时，我们可能会收集或使用您的相关个人信息。鉴此，宇泰云服在线制定了本隐私政策（以下简称“本政策”），旨在向您说明宇泰云服在线如何收集、使用和保护您的个人信息，以及为您提供查阅、更正您个人信息的途径和方法，以便更好的保障您的权益。</p>

    <p class="mar_bottom">
      <span>本政策适用于我们提供的所有宇泰云服在线服务。因此建议您在使用宇泰云服在线服务前，务必仔细阅读本政策。</span>
      <span class="bold">特别是以粗体标识的条款，您应重点阅读，</span>
      <span>在确认充分理解并同意后再开始使用。</span>
      <span class="bold">一旦您开始使用宇泰云服在线服务，即表示您已充分理解并同意本政策。您使用或继续使用宇泰云服在线服务，都表示您同意我们按照本政策（包括更新版本）收集、使用、储存和共享您的个人信息。</span>
    </p>

    <p>为便于您了解本政策内容，您可以根据以下提纲阅读相应章节:</p>
    <p class="bold">一、定义和适用范围</p>
    <p class="bold">二、个人信息控制者基本情况披露</p>
    <p class="bold">三、个人信息的收集、使用</p>
    <p class="bold">四、个人信息的共享、转让、公开披露</p>
    <p class="bold">五、个人信息的存储、保护和管理</p>
    <p class="bold">六、Cookie和同类技术的使用</p>
    <p class="bold">七、未成年人隐私权保护</p>
    <p class="bold">八、查阅、更正个人信息</p>
    <p class="bold">九、隐私政策的修订</p>
    <p class="bold mar_bottom">十、如何联系我们</p>

    <p class="bold">一、定义和适用范围</p>
    <p>1、个人信息：以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</p>
    <p>2、匿名化：通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。</p>
    <p>3、去标识化：通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体的过程。</p>
    <p>本政策适用于宇泰云服在线通过宇泰云服在线官网（网站：wx.ssish.com）、宇泰云服在线移动应用程序，以及合作的第三方向您提供的产品或服务。</p>
    <p class="bold mar_bottom">特别说明：除宇泰云服在线通过合作伙伴向您提供的产品或服务外，本政策不适用于其他第三方单独向您提供的非宇泰云服在线的产品或服务。</p>

    <p class="bold">二、个人信息控制者基本情况披露</p>
    <p>注册名称：宇泰保险经纪（北京）有限公司</p>
    <p>办公地点：北京市朝阳区建国门外大街22号赛特广场3幢3层30306室</p>
    <p class="mar_bottom text_underline">相关负责人联系方式：王勤 <a href="tel:15121033271">15121033271</a></p>

    <p class="bold">三、个人信息的收集、使用</p>
    <p class="mar_bottom">我们收集您的个人信息主要目的是为了您和其他用户能够更容易和更满意地使用宇泰云服在线服务。</p>

    <p class="mar_bottom">（一）我们将通过以下途径收集和获取您的个人信息：</p>

    <p>1.您提供的个人信息。例如：</p>
    <p>（1）您在注册宇泰云服在线相关账户或使用宇泰云服在线服务时，向我们提供的信息；</p>
    <p class="mar_bottom">（2）您通过宇泰云服在线服务向其他方提供的共享信息，以及您使用宇泰云服在线服务时所储存的信息。</p>

    <p class="mar_bottom">2.其他方分享的您的信息（即其他方使用宇泰云服在线服务时所提供的有关您的信息）。</p>

    <p class="mar_bottom">3.我们获取的您的信息。您在使用宇泰云服在线服务时，我们收集、汇总、记录的信息，例如日志信息、位置信息、设备信息。</p>

    <p class="mar_bottom">（二）我们会出于以下目的，收集和使用您以下类型的个人信息：</p>

    <p>1、帮助您完成注册及登录。</p>
    <p>
      <span>为便于我们为您提供服务，您需要提供基本注册信息，包括手机号码、电子邮箱地址，并创建您的账号、用户名和密码。</span>
      <span class="text_underline">在部分服务中，如果您仅需使用浏览、搜索等基本服务，您不需要注册成为宇泰云服在线用户及提供上述信息。</span>
    </p>
    <p  class="mar_bottom">此外，在符合宇泰云服在线服务协议约定条件及国家相关法律法规规定的情况下，我们也提供注册账号的注销服务，您可以拨打宇泰云服在线服务中心（<a href="tel:4008203433">400-820-3433</a>）联系我们处理。</p>
    <p>2、向您提供产品或服务</p>
    <p>
      <span class="bold">我们所收集和使用的个人信息是为您提供宇泰云服在线服务的必要条件，如缺少相关信息，我们将无法为您提供宇泰云服在线服务的核心内容，</span>
      <span>例如：</span>
    </p>
    <p>（1）您在使用宇泰云服在线服务时、上传和/或发布信息以及进行相关行为（例如产品评论、市场活动等）时，我们将收集您上传、发布或形成的信息，并有权展示您的昵称、头像和发布内容；</p>
    <p class="mar_bottom">
      <span>（2）在部分服务项目中，为便于向您交付产品或服务，</span>
      <span class="bold text_underline">您至少需提供投保人、被保险人及受益人的个人身份信息、姓名、投被保人关系、联系电话、银行账号、车辆信息（涉及车险服务时）、个人健康状况信息（涉及健康保险及其服务时）。</span>
      <span>。如果您拒绝提供此类信息，我们将无法完成相关服务。如您通过宇泰云服在线服务为具有保险利益的其他人订购产品或服务，您需要提供该被保险人的前述信息。</span>
      <span class="bold">向我们提供该被保险人的前述信息之前，您需确保您已经取得其授权同意；</span>
    </p>

    <p class="red mar_bottom">（3）您在使用宇泰云服在线支付过程中，微信支付、银联支付等您选择的支付渠道也会留存用户的订单信息，包括：付款人信息（姓名、证件号、银行卡号）、商品信息（投保的产品、金额）、交易日期、收款方；</p>

    <p class="red mar_bottom">（4）当您使用保险公司的理赔服务时，至少需提供出险人姓名、出险日期、健康信息、索赔的影像资料；</p>

    <p class="red mar_bottom">（5）当您使用邮寄服务（纸质保单）时，至少需提供收货人的姓名、手机号、配送地址信息；</p>

    <p class="red mar_bottom">（6）当您在做问卷调查时，我们会根据问卷内容收集您的个人信息、公司信息、从业经历；</p>

    <p class="red mar_bottom">
      <span>（7）当您开启个性化定向推荐功能时，我们会基于收集的信息，对您的偏好、习惯作特征分析和用户画像，以便为您提供更适合的定制化服务，例如向您展现或推荐相关程度更高的线上、线下活动信息。为此</span>
      <span class="text_underline">我们需要收集的信息包括您的设备信息(例如硬件型号、设备MAC地址、IMEI、IDFA、IMSI)、日志信息、浏览记录。</span>
      <span>例如:推荐您可能喜欢的线上、线下活动等。同时，如您不希望接收到我们为您推送的个性化内容，您可以随时使用我们的产品相关功能设置页面开启/关闭推送。</span>
    </p>

    <p class="red mar_bottom">
      <span>(8）当您使用 宇泰云服在线服务时，为保障你正常使用我们的服务，维护我们服务的正常运行，改进及优化我们的服务体验以及保障你的帐号安全，</span>
      <span class="text_underline">我们会收集你的设备型号、品牌、操作系统、唯一设备标识符（指由设备制造商编入到设备中的一串字符，可用于以独有方式标识相应设备）、MAC地址、登录IP地址、宇泰云服微信公众号软件版本号、操作日志、服务日志信息（如你在宇泰云服微信公众号进行浏览、搜索的记录、故障信息）等日志信息，这类信息是为提供服务必须收集的基础信息；</span>
    </p>

    <p>
      <span>（9）为展示您账户的订单信息，</span>
      <span class="bold">我们会收集您在使用宇泰云服在线服务过程中产生的订单信息</span>
      <span>用于向您展示及便于您对订单进行管理；</span>
    </p>
    <p>
      <span>（10）当您与我们联系时，</span>
      <span class="bold">我们可能会保存您的通信/通话记录和内容或您留下的联系方式等信息，</span>
      <span>以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果；</span>
    </p>
    <p>（11）为确认交易状态及为您提供售后与争议解决服务，我们会通过您基于交易所选择的交易对象、支付机构等收集与交易进度相关的您的交易、支付信息，或将您的交易信息共享给上述服务提供者；</p>
    <p>（12）为向您提供更契合您需求的页面展示和推荐个性化内容、进行间接用户画像、了解产品适配性、识别账号异常状态，我们可能会收集关于您使用的服务以及使用方式的信息并将这些信息进行关联，这些信息包括：</p>
    <p>
      <span class="bold">【1】日志信息：</span>
      <span>当您使用我们的服务时，我们可能会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。例如您的登录账号、搜索查询内容、IP地址、浏览器的类型、电信运营商、网络环境、使用的语言、访问日期和时间及您访问的网页浏览记录、打开记录、停留时长、刷新记录、发布记录、关注、订阅、收藏及分享。</span>
    </p>
    <p>
      <span class="bold">【2】设备信息：</span>
      <span>我们可能会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（例如IMEI、MAC、Serial、SIM卡IMSI识别码、设备机型、操作系统及版本、客户端版本、设备分辨率、包名、设备设置、进程及软件列表、唯一设备标识符、软硬件特征信息）、设备所在位置相关信息（例如IP地址、GPS位置以及能够提供相关信息的WLAN接入点、蓝牙和基站传感器信息）。</span>
    </p>
    <p>
      <span class="bold">请注意，单独的设备信息、日志信息是无法识别特定自然人身份的信息。</span>
      <span>如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。</span>
    </p>
    <p>（7）我们通过间接方式收集到的您的个人信息：</p>
    <p>
      <span class="bold">我们可能从关联方、第三方合作伙伴获取您授权共享的相关信息。</span>
      <span>例如，我们可能从第三方获取您授权共享的账户信息（包括用户名、头像、昵称）并在您同意本政策后将您的第三方账户与您的宇泰云服在线服务账户绑定，使您可以通过第三方账户直接登录并使用我们的产品与/或服务。我们将在符合相关法律法规规定，并依据与关联方或第三方合作伙伴的约定、确信其提供的信息来源合法的前提下，收集并使用您的这些信息。</span>
    </p>
    <p>（8）基于上述您向我们提供的信息、我们可能收集的信息及我们通过间接方式收集到的您的信息，并通过对上述一项或几项信息的结合，进行推荐算法建模、程序化广告推荐算法建模、用户行为分析及用户画像，以便向您提供更契合您需求的页面展示和推荐个性化内容。</p>
    <p class="mar_bottom">
      <span>（9）为保证服务得以完成或向你提供你可能需要的服务，我们会通过短信或电话等方式向你发送信息，包括但不限于验证码、保单生效通知、活动信息，或其他你可能感兴趣的信息等。</span>
      <span class="text_underline">如你不希望继续接收上述信息，可以根据信息中提供的退订方式予以退订。</span>
    </p>

    <p>3、向您推送消息</p>
    <p>
      <span>（1）为您展示和推送产品或服务。</span>
      <span class="bold">我们可能使用您的信息（例如您的浏览及搜索记录、设备信息、位置信息、订单信息），用于提取您的浏览、搜索偏好、行为习惯、位置信息相关特征，并基于特征标签通过电子邮件、短信或其他方式向您发送营销信息，提供或推广我们或第三方的产品和服务。</span>
    </p>
    <p class="mar_bottom">
      <span>（2）向您发出通知。我们可能在必需时（例如当我们由于系统维护而暂停某一项服务、变更或终止提供某一项服务时）向您发出与服务有关的通知。</span>
      <span class="bold">如您不希望继续接收我们推送的消息，您可要求我们停止推送，例如：根据短信退订指引要求我们停止发送推广短信，或在移动端设备中进行设置，不再接收我们推送的消息；但我们依法律规定或服务协议约定发送消息的情形除外。</span>
    </p>

    <p>4、为您提供安全保障</p>
    <p class="mar_bottom">
      <span>为提高您使用我们及合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或宇泰云服在线服务相关协议规则的情况，</span>
      <span class="bold">我们可能会收集、使用或整合您的账户信息、交易信息、设备信息、日志信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</span>
    </p>

    <p>5、改进我们的服务</p>
    <p class="mar_bottom">我们可能将通过某一项宇泰云服在线服务所收集的信息，用于我们的其他服务。例如，在您使用某一项宇泰云服在线服务时所收集的您的信息，可能在另一项宇泰云服在线服务中用于向您提供特定内容或向您展示与您相关的、而非普遍推送的信息；我们可能让您参与有关宇泰云服在线服务的调查，帮助我们改善现有服务或设计新服务；同时，我们可能将您的信息用于软件更新。</p>

    <p>6、其他用途</p>
    <p class="mar_bottom">
      <span>您了解并同意，在收集您的个人信息后，我们可能通过技术手段对数据进行去标识化处理，</span>
      <span class="bold">去标识化处理的信息将无法识别您的身份，在此情况下我们有权使用已经去标识化的信息，对用户数据库进行分析并予以商业化的利用，而无需另行获得您的同意。</span>
    </p>
    <p class="bold mar_bottom">请您注意，如果我们要将您的个人信息用于本政策中未载明的其他用途或额外收集未提及的其他个人信息，我们会通过页面提示、交互流程、网站公告或其他方式另行征得您的同意。一旦您同意，该等额外用途将视为本政策的一部分，该等额外信息也将适用本政策。</p>


    <p class="bold">7、征得授权同意的例外</p>
    <p class="bold">根据相关法律法规规定，以下情形中收集您的信息无需征得您的授权同意：</p>
    <p class="bold">（1）与国家安全、国防安全有关的；</p>
    <p class="bold">（2）与公共安全、公共卫生、重大公共利益有关的；</p>
    <p class="bold">（3）与犯罪侦查、起诉、审判和判决执行等有关的；</p>
    <p class="bold">（4）出于维护信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
    <p class="bold">（5）所收集的信息是您自行向社会公众公开的；</p>
    <p class="bold">（6）从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道;</p>
    <p class="bold">（7）根据您的要求签订合同所必需的；</p>
    <p class="bold">（8）用于维护宇泰云服在线服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>
    <p class="bold">（9）为合法的新闻报道所必需的；</p>
    <p class="bold">（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；</p>
    <p class="bold mar_bottom">（11）法律法规规定的其他情形。</p>

    <p class="mar_bottom">
      <span>  8、您理解并同意，部分服务可能需要您在您的设备中开启特定的访问权限（例如您的位置信息、摄像头、相册、麦克风、通讯录及/或日历），以实现这些权限所涉及信息的收集和使用。当您需要关闭该功能时，大多数移动设备都会支持您的这项需求，具体方法请参考或联系您移动设备的服务商或生产商。</span>
      <span class="bold">请您注意，您开启任一权限即代表您授权我们可以收集和使用相关信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关信息，也无法为您提供该权限所对应的服务。</span>
      <span>但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。</span>
    </p>

    <p class="bold">9、有关个人敏感信息的提示</p>
    <p>以上由您提供或我们收集您的信息中，可能包含您的个人敏感信息，例如身份证件号码、银行账号、交易和消费记录、虚拟财产信息、系统账号、邮箱地址及其有关的密码、电话号码、网页浏览记录、位置信息。请您谨慎并留意个人敏感信息，您同意您的个人敏感信息我们可以按本政策所述的目的和方式来处理。</p>
    <p class="bold">当我们要将信息用于本政策未载明的其他用途时，会事先征求您的同意。</p>
    <p class="bold mar_bottom">当我们要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</p>
    
    <p class="bold mar_bottom">四、个人信息的共享、转让或公开披露</p>

    <p>（一）共享</p>
    <p class="bold">除以下情形外，未经您同意，我们不会与宇泰云服在线之外的任何第三方共享您的个人信息：</p>
    <p class="bold">1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</p>
    <p class="bold">2、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</p>
    <p class="bold">3、在法律法规允许的范围内，为了遵守法律、维护我们及我们的关联方或合作伙伴、您或其他宇泰云服在线用户或社会公众利益、财产或安全免遭损害，比如为防止欺诈等违法活动和减少信用风险，我们可能与其他公司和组织交换信息。不过，这并不包括违反本政策中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的信息。</p>
    <p class="bold">4、与我们的关联公司共享：为便于我们基于统一的账号体系向您提供一致化服务以及便于您进行统一管理、个性化推荐、保障系统和账号安全等。您的个人信息可能会与宇泰云服在线的关联公司共享。我们只会共享必要的个人信息，且受本政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。</p>
    <p class="bold">5、与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如：提供支付服务的支付机构、提供数据服务（包括网络广告监测、数据统计、数据分析）的合作伙伴和其他服务提供商。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于其他任何用途。</p>
    <p class="bold">6、应您的监护人合法要求而提供您的信息；</p>
    <p class="bold">7、根据与您签署的服务协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；</p>
    <p class="bold">8、基于学术研究而提供。</p>
    <p class="bold mar_bottom">对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理信息。</p>

    <p>（二）转让</p>
    <p>
      <span class="bold">1、随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，而您的信息有可能作为此类交易的一部分而被转移。我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，</span>
      <span>否则，我们将要求该公司、组织重新向您征求授权同意。</span>
    </p>
    <p class="mar_bottom">2、在获得您的明确同意后，我们会向其他方转让您的个人信息。</p>

    <p>（三）披露</p>
    <p class="bold">我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会披露您的个人信息：</p>
    <p>1、根据您的需求，在您明确同意的披露方式下披露您所指定的信息；</p>
    <p class="mar_bottom">2、根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您信息的情况下，我们可能会依据所要求的信息类型和披露方式披露您的信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求接收方必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。</p>

    <p class="bold">（四）共享、转让、披露信息时事先征得授权同意的例外</p>
    <p class="bold">以下情形中，分享、转让、披露您的信息无需事先征得您的授权同意：</p>
    <p class="bold">1、与国家安全、国防安全有关的；</p>
    <p class="bold">2、与公共安全、公共卫生、重大公共利益有关的；</p>
    <p class="bold">3、与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；</p>
    <p class="bold">4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
    <p class="bold">5、您自行向社会公众公开的信息；</p>
    <p class="bold">6、从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道。</p>
    <p class="bold mar_bottom">7、根据法律规定，共享、转让、披露经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别信息主体的，不属于个人信息的对外共享、转让及公开披露行为。</p>

    <p class="bold">五、个人信息的存储、保护和管理</p>
    <p>我们仅在本政策所述目的所必需期间和法律法规要求的时限内保留您的个人信息。</p>
    <p>在超出上述个人信息保存期限后，我们将会对您的个人信息进行删除或作匿名化处理。</p>
    <p class="bold">我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：</p>
    <p class="bold">1、法律法规有明确规定；</p>
    <p class="bold">2、获得您的授权同意；</p>
    <p class="bold">3、您使用的产品、服务涉及跨境，宇泰云服在线需要向境外提供您的个人信息的。</p>
    <p>针对以上情形，我们会确保依据本政策及国家法律法规要求对您的个人信息提供足够的保护。</p>
    <p>我们非常重视信息安全，成立了专门的安全团队，并采取一切合理可行的措施，保护您的个人信息：</p>
    <p>（一）数据安全技术措施</p>
    <p>我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改，避免数据的损坏或丢失。</p>
    <p>我们从数据的生命周期角度出发，在数据收集、存储、显示、处理、使用、销毁等各个环节建立了安全防护措施，根据信息敏感程度的级别采取不同的控制措施，包括但不限于访问控制、SSL加密传输进行加密存储、敏感信息脱敏显示等。</p>
    <p>我们的服务采取了多种加密技术，例如在某些产品中，我们将利用加密技术（例如SSL）来保护您的个人信息，采取加密技术对您的个人信息进行加密保存，并通过隔离技术进行隔离。</p>
    <p>在个人信息使用时，例如信息展示、信息关联计算，我们会采用多种数据脱敏技术增强信息在使用中的安全性。</p>
    <p>我们还会采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。</p>
    <p>（二）我们为保护个人信息采取的其他安全措施</p>
    <p>我们通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。</p>
    <p>我们通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。</p>
    <p>我们还会举办安全和隐私保护培训课程，加强员工的安全意识以及对于保护信息重要性的认识。</p>
    <p>
      <span>（三）</span>
      <span class="bold">我们仅允许有必要知晓这些信息的宇泰云服在线员工、合作伙伴访问您的个人信息，</span>
      <span>并为此设置了严格的访问权限控制和监控机制。</span>
      <span class="bold">我们同时要求可能接触到您的个人信息的所有人员履行相应的保密义务。</span>
      <span>如果未能履行这些义务，可能会被追究法律责任或被中止与宇泰云服在线的合作关系。</span>
    </p>
    <p>（四）我们会采取一切合理可行的措施，确保未收集无关的个人信息。</p>
    <p>
      <span>（五）互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件或其他服务软件等与其他用户的交流方式无法确定是否完全加密，</span>
      <span class="bold">我们建议您使用此类工具时使用复杂密码，并注意保护您的信息安全。</span>
    </p>
    <p>（六）互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的个人信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致个人信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</p>
    <p>（七）安全事件处置</p>
    <p>
      <span>在通过宇泰云服在线服务与第三方进行沟通或购买产品及服务时，您不可避免的要向交易对方或潜在的交易对方披露自己的信息，如联络方式或者邮政地址等。</span>
      <span class="bold">请您妥善保护自己的信息，仅在必要的情形下向他人提供。</span>
    </p>
    <p>为应对个人信息泄露、损毁和丢失等可能出现的风险，我们制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。我们也为安全事件建立了专门的应急响应团队，按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击，并定期组织内部相关人员进行应急响应培训和应急演练。</p>
    <p>在不幸发生信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报信息安全事件的处置情况。</p>
    <p class="bold mar_bottom">请您理解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。您需要了解，您接入宇泰云服在线服务所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。</p>
    <p class="mar_bottom">
      <span class="bold">请您务必妥善保管好您的账号、密码及其他身份要素。</span>
      <span>您在使用宇泰云服在线服务时，我们会通过您的账号、密码及及其他身份要素来识别您的身份。一旦您泄露了前述信息，您可能会蒙受损失，并可能对您产生不利。</span>
      <span class="bold">如您发现账号、密码及/或其他身份要素可能或已经泄露时，请您立即和我们取得联系，</span>
      <span>以便我们及时采取相应措施以避免或降低相关损失。</span>
    </p>

    <p class="bold">六、Cookie和同类技术的使用</p>
    <p>（一）为实现您联机体验的个性化需求，使您获得更轻松的访问体验。我们会在您的设备上发送一个或多个名为Cookies的小数据文件，指定给您的Cookies是唯一的，它只能被将Cookies发布给您的域中的Web服务器读取。我们向您发送Cookies是为了简化您重复登录的步骤、帮助判断您的登录状态以及账户或数据安全。</p>
    <p>
      <span>（二）我们不会将Cookies用于本政策所述目的之外的任何用途。您可根据自己的偏好管理Cookies。您可以清除软件内保存的所有Cookies。</span>
      <span class="bold">但如果您这么做，您之前所记录的相应信息也均会被删除。</span>
    </p>
    <p class="mar_bottom">（三）Cookies记录的信息包括：加密的用户编号、加密的token、用户唯一标识等。</p>

    <p class="bold">七、未成年人隐私权保护</p>
    <p>宇泰云服在线重视未成年人的信息保护。如您为未成年人，您务必请您的父母或监护人仔细阅读本政策，并在征得您父母或监护人同意的前提下才能向宇泰云服在线提供信息、使用宇泰云服在线的服务或购买宇泰云服在线的产品等。</p>
    <p class="mar_bottom">对于经父母同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。</p>

    <p class="bold">八、查阅、更正、删除、注销个人信息</p>
    <p class="mar_bottom">按照中国相关的法律、法规、标准，以及其他国家、地区的同行做法，我们保障您对自己的个人信息行使以下权利：</p>

    <p class="bold">1、访问您的个人信息</p>
    <p>您可以在我们系统中查阅您的保单信息、理赔信息、预约信息。</p>
    <p class="mar_bottom">微信端您可以从“宇泰云服”公众号 - “产品中心”进入，进行个人信息的维护，或进入保单列表，点击保单可以查看保单信息，理赔信息和预约信息。</p>

    <p class="bold">2、更正您的个人信息</p>
    <p class="mar_bottom">如果您希望编辑您的帐户中的个人资料信息，您可以通过“1、访问您的个人信息”中罗列的方式进行更正。</p>

    <p class="bold">3、删除您的个人信息</p>
    <p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
    <p>（1）如果您注销了账户；</p>
    <p>（2）如果我们终止服务及运营。</p>
    <p class="mar_bottom">若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的其他主体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。(备份更新的时间与我们技术体系和业务发展有关，在删除之前，我们对您的数据安全存储并不做任何使用)。</p>

    <p class="bold">4、个人信息主体注销账户</p>
    <p class="mar_bottom">
      <span>您可以通过联系我们的客服</span>
      <span class="text_underline">（<a href="tel:4008203433">400-820-3433</a>）</span>
      <span>，来注销您的帐户。您注销账户后，我们将停止为您提供产品与/或服务，并依据您的要求，除法律法规另有规定外，我们将及时删除您的个人信息。</span>
    </p>

    <p class="bold">5、响应您的上述请求</p>
    <p>为保障安全，宇泰云服在线可能会先要求您验证自己的身份，然后再处理您的请求。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，宇泰云服在线可能会予以拒绝。</p>
    <p class="bold">在以下情形中，按照法律法规要求，宇泰云服在线将无法响应您的请求：</p>
    <p class="bold">（1）与国家安全、国防安全有关的；</p>
    <p class="bold">（2）与公共安全、公共卫生、重大公共利益有关的；</p>
    <p class="bold">（3）与犯罪侦查、起诉、审判和执行判决等有关的；</p>
    <p class="bold">（4）有充分证据表明个人信息主体存在主观恶意或滥用权利的；</p>
    <p class="bold">（5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
    <p class="bold mar_bottom">（6）涉及商业秘密的。</p>

    <p class="bold">九、本政策的修订</p>
    <p class="mar_bottom">
      <span>宇泰云服在线可能适时修订本政策，一旦本政策内容发生变更，</span>
      <span class="text_underline">微信公众号（宇泰云服）公布最新的隐私政策，并通过显著的方式通知您。</span>
      <span class="bold">若您在本政策修订后继续使用宇泰云服在线提供的产品或服务，这表示您已充分阅读、理解并愿意受修订后的隐私政策约束。</span>
    </p>

    <p>十、如何联系我们</p>
    <p>任何与您个人信息有关的请求或投诉，请发送电子邮件至：<span class="text_underline">kefu@ssish.com</span> 或者拨打客服热线：<a href="tel:4008203433" class="text_underline">400-820-3433</a></p>

  </div>
</template>
<script>
export default {
  created() {
    document.title = "宇泰保险经纪宇泰云服隐私政策"
  },
}
</script>

<style lang="scss" scoped>
  .box {
    padding: 21px 20px;
    box-sizing: border-box;
    font-size: 13px;
    .mar_bottom {
      margin-bottom: 19px;
    }
    .text_underline {
      text-decoration: underline;
    }
    .label {
      display: inline-block;
      width: 120px;
    }
    p,
    span {
      padding: 0;
      margin: 0;
      text-align: left;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 19px;
      word-break: break-all;
    }
    .bold {
      color: #333;
      font-weight: bold;
      font-family: Medium;
    }
    .red {
      color: red;
      span {
        color: red;
      }
    }
  }
</style>
